"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsStoreBusyValid = void 0;
exports.parseInstantGglocations = parseInstantGglocations;
exports.parseTimeSlotGglocations = parseTimeSlotGglocations;
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
var _utils = require("@spq/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function parseGglocation(gglocation) {
  var deliveryProcessingTime = gglocation.deliveryProcessingTime,
    scheduledDeliveryCutoffTime = gglocation.scheduledDeliveryCutoffTime,
    processingTime = gglocation.processingTime,
    cutoffTime = gglocation.cutoffTime;
  var otherValues = (0, _lodash.pickBy)(gglocation, function (value, key) {
    return !["deliveryProcessingTime", "scheduledDeliveryCutoffTime", "processingTime", "cutoffTime", "scheduledDeliveryOrderTime", "scheduledOrderTime", "scheduledDeliveryOrderCutoffTime", "scheduledOrderCutoffTime"].includes(key);
  });
  return _objectSpread({
    processingTime: {
      "default": processingTime,
      delivery: deliveryProcessingTime
    },
    cutoffTime: {
      "default": cutoffTime,
      delivery: scheduledDeliveryCutoffTime
    }
  }, otherValues);
}
var parseScheduledOrderTimes = function parseScheduledOrderTimes(scheduledOrderTimes) {
  return (0, _lodash.chain)(scheduledOrderTimes).flatMap().groupBy(function (scheduleOrderTime) {
    return (0, _moment["default"])(scheduleOrderTime).format("YYYY-MM-DD");
  }).value();
};
function parseInstantGglocations(gglocations) {
  var result = {
    gglocations: {}
  };
  gglocations.forEach(function (gglocation) {
    var gglocationType = gglocation.gglocationType,
      gglocationId = gglocation.gglocationId,
      scheduledDeliveryOrderTime = gglocation.scheduledDeliveryOrderTime,
      scheduledOrderTime = gglocation.scheduledOrderTime;
    var id = "".concat(gglocationType, "_").concat(gglocationId);
    var scheduledOrderTimes = (0, _lodash.mapValues)({
      "default": scheduledOrderTime,
      delivery: scheduledDeliveryOrderTime
    }, parseScheduledOrderTimes);
    result.gglocations[id] = _objectSpread(_objectSpread({}, parseGglocation(gglocation)), {}, {
      id: id,
      type: "instant",
      openingHours: gglocation.openingHours.sort(_utils.compareDates),
      scheduledOrderTimes: scheduledOrderTimes
    });
  });
  return result;
}
function parseTimeSlotGglocations(gglocations) {
  var result = {
    timeSlots: {},
    gglocations: {}
  };
  gglocations.map(function (gglocation) {
    var timeSlotIds = gglocation.timeSlots.sort(function (timeSlotA, timeSlotB) {
      return (0, _utils.compareDates)(timeSlotA.datetime, timeSlotB.datetime);
    }).map(function (timeSlot) {
      var timeSlotId = timeSlot.id.toString();
      result.timeSlots[timeSlotId] = _objectSpread(_objectSpread({}, timeSlot), {}, {
        id: timeSlotId
      });
      return timeSlotId;
    });
    var id = "".concat(gglocation.gglocationType, "_").concat(gglocation.gglocationId);
    result.gglocations[id] = _objectSpread(_objectSpread({}, parseGglocation(gglocation)), {}, {
      id: id,
      type: "scheduled",
      timeSlots: timeSlotIds
    });
    return gglocation;
  });
  return result;
}
var checkIsStoreBusyValid = exports.checkIsStoreBusyValid = function checkIsStoreBusyValid(_ref) {
  var startTime = _ref.startTime,
    endTime = _ref.endTime,
    isManuallyCancelled = _ref.isManuallyCancelled;
  return (0, _moment["default"])().isBetween(startTime, endTime) && !isManuallyCancelled;
};